import React, { useState, useEffect } from 'react';
import { Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel } from 'swiper/modules';
import cx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../buttons/BabyButton/Base.js';
import '../../buttons/BabyButton/variants/Chat/index.js';
import '../../buttons/BabyButton/variants/Menu/index.js';
import '../../buttons/BabyButton/variants/User/index.js';
import '../../buttons/BabyButton/variants/Vip/index.js';
import '../../buttons/BabyButton/variants/Wallet/index.js';
import '../../buttons/Button/index.js';
import '../../buttons/CloseButton/index.js';
import '../../buttons/DirectionButton/index.js';
import '../../buttons/GradientButton/index.js';
import { GradientButtonV2 } from '../../buttons/GradientButtonV2/index.js';
import '../../buttons/TabButton/index.js';
import '../../buttons/TabButtonV2/index.js';
import '../../buttons/TimerButton/index.js';
import '../../buttons/TimerButtonV2/index.js';
import '../../buttons/TimerButtonV3/index.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import { ChevronDown } from '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import styles from './index.module.scss.js';

const Next = ({ ...props }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...props,
    className: cx(styles.button, props.className),
    type: "button"
  },
  /* @__PURE__ */ React.createElement(ChevronDown, null)
);
const Tabs = ({
  defaultActiveIndex = 0,
  buttons = [],
  onChange = () => {
  },
  animation = {
    "data-aos": "fade-up",
    "data-aos-delay": "50",
    "data-aos-duration": "1000"
  },
  v2,
  className,
  ...props
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);
  const [swiper, setSwiper] = useState(null);
  useEffect(() => {
    console.log("defaultActiveIndex", defaultActiveIndex);
    setActiveIndex(defaultActiveIndex);
  }, [defaultActiveIndex]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      ...animation,
      className: cx(styles.box, className, {
        [styles.v2]: v2
      })
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.box__inner, {
          [styles["swiper-shadow"]]: !swiper?.isEnd
        })
      },
      /* @__PURE__ */ React.createElement(
        Swiper,
        {
          className: styles.swiper,
          modules: [Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel],
          spaceBetween: 0,
          slidesPerView: "auto",
          height: 60,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          direction: "horizontal",
          freeMode: true,
          mousewheel: {
            thresholdDelta: 0.1,
            sensitivity: 10
          },
          onBeforeInit: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          },
          onAfterInit: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          },
          onResize: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          }
        },
        buttons.map(({ icon, label }, i) => /* @__PURE__ */ React.createElement(SwiperSlide, { className: styles.slide, key: `${`${i}-${label}`}` }, /* @__PURE__ */ React.createElement(
          GradientButtonV2,
          {
            active: activeIndex === i,
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();
              setActiveIndex(i);
              onChange(i);
            },
            name: label,
            icon,
            size: "sm",
            className: cx(styles["gradient-btn"], {
              [styles.active]: activeIndex === i
            }),
            v2: true
          }
        )))
      ),
      !swiper?.isEnd && /* @__PURE__ */ React.createElement(Next, { onClick: () => swiper?.slideNext() })
    )
  );
};
Tabs.displayName = "Tabs";

export { Tabs };
//# sourceMappingURL=index.js.map
